export default "__VITE_ASSET__Nscddrvx__"